"use client";

import React from "react";
import { Play, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTrigger, DialogTitle, DialogDescription } from "@/components/ui/dialog";
export default function RollingIntoYourNeighborhood() {
  return <section data-section-id="222012" id="rolling-into-your-neighborhood" className="bg-background text-foreground relative w-full h-[100svh] min-h-[600px] flex items-center justify-center overflow-hidden">
      {}
      <div className="absolute inset-0 w-full h-full z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685947/img/rolling_tacos_truck_sunset.png" alt="Rolling Tacos Truck" className="absolute inset-0 w-full h-full object-cover scale-105" />
        {}
        <div className="absolute inset-0 bg-black/40 z-10 mix-blend-multiply opacity-80" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-background z-10" />
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/asfalt-dark.png')] opacity-30 z-15 pointer-events-none" />
      </div>

      {}
      <div className="relative z-20 container mx-auto px-4 md:px-6 flex flex-col items-center text-center mt-16">
        <div className="max-w-5xl space-y-8 animate-in fade-in slide-in-from-bottom-8 duration-1000 fill-mode-both">
          
          <h1 className="font-default text-5xl sm:text-6xl md:text-[12vw] leading-[0.9] font-bold tracking-tighter text-white drop-shadow-[0_2px_2px_rgba(249,115,22,1)] uppercase">
            Rolling Into Your Neighborhood
          </h1>
          
          <p className="font-sans text-lg sm:text-xl md:text-[22px] text-white/95 max-w-3xl mx-auto leading-relaxed drop-shadow-lg font-medium">
            The streets are calling. Catch the heat with our signature habanero-infused tacos, served fresh from the truck to your hands.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-8">
            <Link to="/HomePage">
              <Button size="lg" className="h-16 px-12 rounded-md text-xl font-bold bg-primary text-primary-foreground hover:bg-primary/90 transition-all shadow-3xl animate-pulse w-[300px] border-2 border-primary">
                LOCATE THE TRUCK
                <ArrowRight className="ml-2 size-6" />
              </Button>
            </Link>

            <Dialog>
              <DialogTrigger asChild>
                <Button variant="outline" size="lg" className="h-16 px-8 rounded-md text-xl font-bold border-white/40 text-white bg-black/40 hover:bg-white/10 hover:text-white backdrop-blur-md transition-all shadow-xl">
                  <Play className="mr-2 size-6 fill-white" />
                  WATCH REEL
                </Button>
              </DialogTrigger>
              <DialogContent className="sm:max-w-4xl p-0 overflow-hidden border-2 border-primary bg-black rounded-md shadow-4xl">
                <div className="sr-only">
                  <DialogTitle>Rolling Tacos Street Vibes</DialogTitle>
                  <DialogDescription>Experience the energy of our mobile kitchen in action.</DialogDescription>
                </div>
                <div className="relative w-full aspect-video bg-black">
                  <iframe className="absolute inset-0 w-full h-full" src="https://www.youtube.com/embed/dQw4w9WgXcQ?autoplay=1&mute=1" title="Rolling Tacos Reel" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                </div>
              </DialogContent>
            </Dialog>
          </div>

        </div>
      </div>
    </section>;
}